export function arrayChunk<T>(arr: T[], itemsPerChunk: number) {
    const array = arr.slice();
    const chunks = [];
    while (array.length) chunks.push(array.splice(0, itemsPerChunk));
    return chunks;
  };